import {ChangeDetectionStrategy, Component} from '@angular/core'
import {LinkService} from '../../../../../i18n/link.service'
import {BreakpointService} from '../../../../../../craft/utils/breakpoint.service'
import {PUBLIC_ROUTES} from '../../../../../../shared/routing/public.routes'
import {ArticleContentService} from '../../../../../content/services/article-content.service'
import {Observable} from 'rxjs'
import {TopicArticle} from '../../../../../content/types/article.types'

@Component({
  selector: 'bgo-topic-overview-submenu',
  templateUrl: './topic-overview-submenu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ArticleContentService],
})
export class TopicOverviewSubmenuComponent {
  readonly topics$ = this.contentService.getTopicList()
  readonly APPLICATION_ROUTES = PUBLIC_ROUTES

  /* topic -> articles */
  private readonly articleCache = new Map<string, Observable<TopicArticle[]>>()

  constructor(
    private readonly contentService: ArticleContentService,
    readonly breakpointService: BreakpointService,
    readonly linkService: LinkService,
  ) {}

  articlesFromTopic$(topicId: string) {
    if (this.articleCache.has(topicId)) {
      // use cache if available
      return this.articleCache.get(topicId)
    } else {
      // fetch from network
      const articles$ = this.contentService.getTopicArticles(topicId)
      this.articleCache.set(topicId, articles$)
      return articles$
    }
  }
}
